import { useState } from 'react'
import Axios from 'axios'
const Form = () => {
    const [userData, setUserData] = useState({
        name: "",
        email: "",
        phone: "",
        business: "",
        businessType: "",
        companyName: "",
        message: "",
    })

    const [errors, setErrors] = useState({
        nameError: "",
        emailError: "",
        phoneError: "",
        businessError: "",
        businessTypeError: "",
        companyNameError: ""
    })

    let name, value;
    const postUserData = (event) => {
        name = event.target.name
        value = event.target.value

        setUserData({ ...userData, [name]: value })
    }

    const submitData = async (event) => {
        event.preventDefault()
        const { name, email, phone, business, businessType, companyName, message } = userData
        const { nameError, emailError, phoneError, businessError, businessTypeError, companyNameError } = errors

        if (name == "") {
            errors.nameError = 'Name is required'
        }
        if (email == "") {
            errors.emailError = 'Email is required'
        }
        else if (!/\S+@\S+\.\S+/.test(email)) {
            errors.emailError = 'Email address is invalid';
        }
        if (phone == "") {
            errors.phoneError = 'Phone is required'
        } else if (phone.length < 10) {
            errors.phoneError = 'Phone Number is invalid';
        }
        if (business == "") {
            errors.businessError = 'Business is required';
        }
        if (businessType == "") {
            errors.businessTypeError = 'Business Type is required';
        }
        if (companyName == "") {
            errors.companyNameError = 'Company Name is required';
        }

        if (
            nameError == "" ||
            emailError == "" ||
            phoneError == "" ||
            businessError == "" ||
            businessTypeError == "" ||
            companyNameError == ""
        ) {
            try {
                const data = await Axios.post("http://localhost:8000/inquiry", { name, email, phone, business, businessType, companyName, message })
                setUserData({
                    name: "",
                    email: "",
                    phone: "",
                    business: "",
                    businessType: "",
                    companyName: "",
                    message: "",
                })
                if (data) {
                    alert("Data Stored")
                } else alert(
                    ("Data not saved")
                )
            } catch (error) {
                console.log(error)
            }
        } else {
            setErrors({ nameError, emailError, phoneError, businessError, businessTypeError, companyNameError })
            console.log(errors);
        }

    }
    return (
        <>
            <form method="POST" className="mt-5 container g-3 needs-validation" noValidate>
                <div className="row"
                    data-aos="fade-down"
                    data-aos-delay="200"
                    data-aos-duration="1000">
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <input type="text" className="form-control" id="name" name="name" placeholder="Enter Name" onChange={postUserData}
                            value={userData.name} required />
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <input type="email" className="form-control" id="email" name="email" placeholder="Enter Email" onChange={postUserData}
                            value={userData.email} required />
                        {errors.emailError && (
                            <p className="help is-danger text-danger">{errors.emailError}</p>
                        )}
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <input type="number" className="form-control" id="phone" name="phone" placeholder="Enter Phone" onChange={postUserData}
                            value={userData.phone} required />
                        {errors.phoneError && (
                            <p className="help is-danger text-danger">{errors.phoneError}</p>
                        )}
                    </div>
                </div>
                <div className="row"
                    data-aos="fade-down"
                    data-aos-delay="200"
                    data-aos-duration="1000">
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <select className="form-select" aria-label="Select Business You Have" id="business" name="business" onChange={postUserData}
                            value={userData.business} required>
                            <option defaultValue>Select Business You Have</option>
                            <option value="Existing Business">Existing Business</option>
                            <option value="New Business (Startup)">New Business (Startup)</option>
                        </select>
                        {errors.businessError && (
                            <p className="help is-danger text-danger">{errors.businessError}</p>
                        )}
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <input type="text" className="form-control" id="businessType" name="businessType" placeholder="Enter Business Type" onChange={postUserData}
                            value={userData.businessType} required />
                        {errors.businessTypeError && (
                            <p className="help is-danger text-danger">{errors.businessTypeError}</p>
                        )}
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <input type="text" className="form-control" id="companyName" name="companyName" placeholder="Enter Company Name" onChange={postUserData}
                            value={userData.companyName} required />
                        {errors.companyNameError && (
                            <p className="help is-danger text-danger">{errors.companyNameError}</p>
                        )}
                    </div>
                </div>
                <textarea className="form-control" id="message" name="message" placeholder="Type your requirement" onChange={postUserData}
                    value={userData.message}
                    data-aos="fade-down"
                    data-aos-delay="200"
                    data-aos-duration="1000"></textarea>
            </form>

            <button type="submit" onClick={submitData} className="info-btn btn btn-outline-danger fw-bold border border-danger mb-0 px-4 mt-3 rounded-pill border-2"
                data-aos="zoom-in"
                data-aos-delay="200"
                data-aos-duration="1000"
            >Submit Now</button>
        </>
    )
}

export default Form